import { ChevronUp, ChevronDown } from 'lucide-react'
import { cn } from '@/shared/lib/utils'

interface PrecadrageAccordionProps {
  number: number
  title: string
  isOpen: boolean
  onToggle: () => void
  children: React.ReactNode
}

export function PrecadrageAccordion({
  number,
  title,
  isOpen,
  onToggle,
  children,
}: PrecadrageAccordionProps) {
  return (
    <div
      className={cn(
        'overflow-hidden rounded-xl border border-border bg-card transition-all',
        isOpen && 'ring-1 ring-accent/20'
      )}
    >
      {/* Header */}
      <button
        type="button"
        onClick={onToggle}
        className="flex w-full items-center justify-between p-4 text-left transition-colors hover:bg-background-secondary/50"
      >
        <div className="flex items-center gap-3">
          <div
            className={cn(
              'flex h-8 w-8 items-center justify-center rounded-lg text-sm font-semibold',
              isOpen ? 'bg-accent text-white' : 'bg-foreground-muted text-white'
            )}
          >
            {number}
          </div>
          <span className="text-base font-semibold text-foreground">{title}</span>
        </div>
        {isOpen ? (
          <ChevronUp className="h-5 w-5 text-foreground-muted" />
        ) : (
          <ChevronDown className="h-5 w-5 text-foreground-muted" />
        )}
      </button>

      {/* Content */}
      <div
        className={cn(
          'grid transition-all duration-200 ease-in-out',
          isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
        )}
      >
        <div className="overflow-hidden">
          <div className="flex flex-col gap-4 px-4 pb-4">{children}</div>
        </div>
      </div>
    </div>
  )
}
